import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eb10bd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggle on" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0 12C0 8.13401 3.13401 5 7 5H17C20.866 5 24 8.13401 24 12C24 15.866 20.866 19 17 19H7C3.13401 19 0 15.866 0 12ZM7 7H17C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7Z",
  fill: "fillColor"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(["svg-toggle", _ctx.checked ? 'on' : 'off']),
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _hoisted_2,
      _createElementVNode("circle", {
        cx: "16",
        cy: "12",
        r: "4.5",
        fill: "white",
        stroke: "none",
        class: _normalizeClass(_ctx.checked ? 'cir-right' : 'cir-left')
      }, null, 2)
    ], 2))
  ]))
}